import { personalInfo } from '../data/portfolio';

export const generatePersonStructuredData = () => {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        "@id": "https://achrefsamoud.com/#person",
        "name": "Achref Samoud",
        "givenName": "Achref",
        "familyName": "Samoud",
        "url": "https://achrefsamoud.com",
        "image": {
          "@type": "ImageObject",
          "url": "https://achrefsamoud.com/images/profile.jpg",
          "width": 400,
          "height": 400
        },
        "sameAs": [
          personalInfo.contact.linkedin,
          personalInfo.contact.github,
          personalInfo.contact.gitlab
        ],
        "jobTitle": "Software Engineer",
        "description": "Software Engineer & DevOps Researcher in Montreal, Quebec",
        "worksFor": {
          "@type": "Organization",
          "name": "Various Organizations in Montreal"
        },
        "alumniOf": [
          {
            "@type": "EducationalOrganization",
            "name": "École de technologie supérieure (ÉTS)",
            "location": "Montreal, Quebec, Canada"
          },
          {
            "@type": "EducationalOrganization", 
            "name": "Institut Supérieur d'Informatique (ISI)",
            "location": "Ariana, Tunisia"
          }
        ],
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Montreal",
          "addressRegion": "Quebec",
          "addressCountry": "Canada"
        },
        "knowsAbout": [
          "Software Engineering",
          "React",
          "TypeScript", 
          "DevOps",
          "CI/CD Automation",
          "Full Stack Development",
          "Cloud Infrastructure",
          "Web Development"
        ],
        "email": personalInfo.contact.email
      },
      {
        "@type": "WebSite",
        "@id": "https://achrefsamoud.com/#website",
        "url": "https://achrefsamoud.com",
        "name": "Achref Samoud Portfolio",
        "description": "Professional portfolio of Achref Samoud, Software Engineer & DevOps Researcher in Montreal, Quebec",
        "publisher": {
          "@id": "https://achrefsamoud.com/#person"
        },
        "inLanguage": "en-CA",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://achrefsamoud.com/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "ProfessionalService",
        "@id": "https://achrefsamoud.com/#service",
        "name": "Achref Samoud - Software Development Services",
        "description": "Professional software development and DevOps engineering services in Montreal, Quebec",
        "provider": {
          "@id": "https://achrefsamoud.com/#person"
        },
        "areaServed": {
          "@type": "Place",
          "name": "Montreal, Quebec, Canada"
        },
        "serviceType": [
          "Web Development",
          "Software Engineering", 
          "DevOps Engineering",
          "Full Stack Development",
          "React Development",
          "TypeScript Development"
        ]
      }
    ]
  };
};